module.exports = __webpack_public_path__ + "fonts/ionicons.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionicons/fonts/ionicons.eot?v=2.0.1
// module id = 1284
// module chunks = 2